import { Map } from 'immutable'
import { normalize, schema } from 'normalizr'
import { createReducer } from '@cheesecakelabs/boilerplate/utils'

import { LOGOUT } from '../user/actions'

import { CREATE_ENGAGEMENT_ENTRY, GET_ENGAGEMENT_ENTRIES } from './actions'

export const INITIAL_STATE = new Map()

export const engagementEntrySchema = new schema.Entity(
  'engagementEntry',
  {},
  { idAttribute: '_id' }
)

export const engagement = createReducer(INITIAL_STATE, {
  [CREATE_ENGAGEMENT_ENTRY.FULFILLED]: (state, { payload }) =>
    state.mergeDeep(normalize(payload, [engagementEntrySchema]).entities.engagementEntry),

  [GET_ENGAGEMENT_ENTRIES.FULFILLED]: (state, { payload }) =>
    state.mergeDeep(normalize(payload, [engagementEntrySchema]).entities.engagementEntry),

  [LOGOUT]: () => INITIAL_STATE,
})



// WEBPACK FOOTER //
// ./src/modules/engagement/reducers.js